/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'maximize': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M832 928H192c-52.928 0-96-43.072-96-96V192c0-52.928 43.072-96 96-96h640c52.928 0 96 43.072 96 96v640c0 52.928-43.072 96-96 96zM192 160c-17.632 0-32 14.368-32 32v640c0 17.664 14.368 32 32 32h640c17.664 0 32-14.336 32-32V192c0-17.632-14.336-32-32-32H192z"/>'
  }
})
